export default __webpack_public_path__ + "static/media/customize-feature.a395ec96.png";